import filter from 'lodash-es/filter';

export const singleOrDefault = <T>(list: Array<T>, predicate: (item: T) => boolean) => {
  const matches = filter(list, predicate);
  if (matches.length > 1) throw new Error('expected to match at most one item');
  return matches[0];
};
